import React from 'react';
interface ScrollHintTableProps {
  children: React.ReactNode;
  minWidth?: string;
}
export function ScrollHintTable({
  children,
  minWidth = '560px'
}: ScrollHintTableProps) {
  return <div data-id="element-292" data-mp="1i7eim9hxx1bw">
      <p className="mb-2 text-center text-xs font-medium text-muted sm:hidden" data-id="element-293" data-mp="1i6wgiw8ljsw2">
        ← Desliza para ver la tabla completa →
      </p>
      <div className="scrollbar-hide overflow-x-auto rounded-2xl border border-slate-200" data-id="element-294" data-mp="1mzfwu0yo524k">
        <div style={{
        minWidth
      }} data-id="element-295" data-mp="1rwfzs3081org">{children}</div>
      </div>
    </div>;
}